import Checkers from "../../../../../../helpers/class/Checkers";
import { useT } from '../../../../../../helpers/i18n';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBenchTree as fasBenchTree, faHome as fasHome} from "@fortawesome/pro-solid-svg-icons";
import Methods from "../../../../../../helpers/class/Methods";
import SpacesMenu from "../../../partials/spaces/SpacesMenu";
import SpacesTabContent from "../../../partials/spaces/SpacesTabContent";
import * as React from "react";
import {useInViewport} from "react-in-viewport";
import Skeleton from "react-loading-skeleton";
import {useRef} from "react";

export default function CompactSpaces ( props : { areaSqm, areaOutdoorSqm, spaces } ){
  const t = useT();

    const config = {disconnectOnLeave: false};

    const options = {};

    const myRef = useRef();

    const {
        inViewport
    } = useInViewport(
        myRef,
        options,
        config
    );

    return (
        <>
            {
                !inViewport ?
                    <>
                        <div ref={myRef}>
                            <Skeleton height={30} className="col-8 col-sm-5 col-md-3 b-rad-md mb-1"/>
                            <Skeleton height={42} className="col-8 col-sm-6 col-md-4 b-rad-md mb-2"/>
                            <Skeleton height={70} className="col-12 col-sm-10 col-md-8 b-rad-md mb-1"/>
                            <Skeleton height={150} className="col-12 b-rad-lg"/>
                        </div>
                    </>
                    :
                    <>
                        <div className="col-12">
                            <p className="block-title m-t-40 hint-text no-margin">{t('property.spaces')}</p>
                            <h2 className="m-t-5">{t('property.layout')}</h2>
                            {/*<p></p>*/}
                            <div className="row w-100 no-margin pt-4">
                                {
                                    props.areaSqm != null && Checkers.isValidPositiveNumber(props.areaSqm) &&
                                    <div className="col-auto ps-0">
                                        <div>
                                            <p className="m-b-30 fs-14">
                                                <FontAwesomeIcon icon={fasHome} className="text-master m-r-10"
                                                                 size="2x"/> {props.areaSqm}
                                                {t('unit.sqm')}. ({Methods.floatFormat((props.areaSqm * 10.764), 2)} {t('unit.sqft')})
                                            </p>
                                        </div>
                                    </div>
                                }
                                {
                                    props.areaOutdoorSqm != null && Checkers.isValidPositiveNumber(props.areaOutdoorSqm) &&
                                    <div className="col-auto ps-0">
                                        <div>
                                            <p className="fs-14 m-b-30">
                                                <FontAwesomeIcon icon={fasBenchTree} className="text-master m-r-10"
                                                                 size="2x"/> {props.areaOutdoorSqm}
                                                {t('unit.sqm')}. ({Methods.floatFormat((props.areaOutdoorSqm * 10.764), 2)} {t('unit.sqft')})
                                            </p>
                                        </div>
                                    </div>
                                }
                            </div>
                            {
                                Checkers.isValidArray(props.spaces) &&
                                <div className="row w-100 no-margin">
                                    <div className="col-md-12 no-padding">
                                        <div className="card card-transparent ">
                                            <SpacesMenu
                                                spaces={props.spaces}
                                            />
                                            <SpacesTabContent
                                                spaces={props.spaces}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </>
            }
        </>
    )
}